import { useMemo, useSyncExternalStore } from "react";
import type { MiningSnapshot } from "../../../mining-engine/types";

export interface MiningSnapshotSource {
  subscribe(listener: () => void): () => void;
  getSnapshot(): MiningSnapshot;
}

// Only these display fields may change without invalidating feature composition.
// Every other snapshot field (including future fields) remains immediate.
const telemetryKeys = new Set<keyof MiningSnapshot>([
  "attempts", "attemptsText", "hashesPerSecond", "activeElapsedMs", "estimatedTimeMs",
]);

export function useMiningLifecycle(source: MiningSnapshotSource): MiningSnapshot {
  const readLifecycle = useMemo(() => {
    let previous = source.getSnapshot();
    return () => {
      const current = source.getSnapshot();
      if ((Object.keys(current) as Array<keyof MiningSnapshot>).some(key =>
        !telemetryKeys.has(key) && !Object.is(previous[key], current[key]))) previous = current;
      return previous;
    };
  }, [source]);
  return useSyncExternalStore(source.subscribe, readLifecycle, readLifecycle);
}
